(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var notificationInit = function () {

    var currentTime = new Date().getTime();
    var expirationTime = new Date(currentTime + 2 * 60 * 60 * 1000).getTime();
    var $self = $(this);
    var $closeButton = $('.close-button', $self);

    if (sessionStorage.getItem('firstNotificationTime') == null || sessionStorage.getItem('firstNotificationTime') < currentTime) {
      $self.css('display', 'flex').hide().fadeIn(250);
      $('body').addClass('overflow');

      $closeButton.on('click', () => {
        $self.fadeOut(250);
        $('body').removeClass('overflow');

        sessionStorage.setItem('firstNotificationTime', expirationTime);
      });
    }
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.firstNotification = {
    attach: function (context) {
      $(context).find('.cc--first-visit-notification').once('firstNotification').each(function () {
        notificationInit.apply(this);
      });
    }
  };

}(jQuery));
